function HolidayCreatePage() {
	return <div>HolidayCreatePage</div>;
}

export default HolidayCreatePage;
